import { render, staticRenderFns } from "./Course-item.vue?vue&type=template&id=ecf91b0a&scoped=true&"
import script from "./Course-item.vue?vue&type=script&lang=js&"
export * from "./Course-item.vue?vue&type=script&lang=js&"
import style0 from "./Course-item.vue?vue&type=style&index=0&id=ecf91b0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf91b0a",
  null
  
)

export default component.exports